const base58_chars = require('./base58_chars.js')

/**
 * converts a base58 to its corresponding binary representation [Uint8Array](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array)
 * @kind function
 * @name base58_to_binary
 * @param {base58_chars} base58String base58 encoded string
 * @returns {Uint8Array} binary representation for the base58 string
 * @example <caption>base58 to binary</caption>
 * ```js
 * import { base58_to_binary } from '@relocke/base58'
 *
 * const bin = base58_to_binary("6MRy")
 * console.log(bin) // Uint8Array(3) [15, 239, 64]
 * Buffer.from(bin).toString('hex') // 0fef40
 * ```
 */
const base58_to_binary = base58String => {
  if (!base58String || typeof base58String !== 'string')
    throw new Error(`Expected base58 string but got “${base58String}”`)
  if (base58String.match(/[IOl0]/gm))
    throw new Error(
      `Invalid base58 character “${base58String.match(/[IOl0]/gm)}”`
    )
  const lz = base58String.match(/^1+/gm)
  const psz = lz ? lz[0].length : 0
  const size =
    ((base58String.length - psz) * (Math.log(58) / Math.log(256)) + 1) >>> 0

  return new Uint8Array([
    ...new Uint8Array(psz),
    ...base58String
      .match(/.{1}/g)
      .map(i => base58_chars.indexOf(i))
      .reduce((acc, i) => {
        acc = acc.map(j => {
          const x = j * 58 + i
          i = x >> 8
          return x
        })
        return acc
      }, new Uint8Array(size))
      .reverse()
      .filter((lastValue => value => (lastValue = lastValue || value))(false))
  ])
}

module.exports = base58_to_binary
